import RedirectionHandler from "../../common/handlers/RedirectionHandler";
import { getFullUrl } from "../../utils/helper";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { SectorSectionContent } from "./types";

const SectorSection = ({ content }: { content: SectorSectionContent }) => {
    const { list } = content;
    const objValueList = Object.values(list);

    return (
        <div className={`flex justify-between px-[16px] py-[12px] text-[16px] font-medium text-[#1056aa] max-sm:text-[12px]`}>
            {objValueList?.map((item, index) => {
                const rawSrc = isOpenInApp()
                    ? (item?.mobileImage ?? "")
                    : (item?.desktopimage ?? "");
                const src = getFullUrl(rawSrc);

                return (
                <RedirectionHandler key={index} url={isOpenInApp() ? item?.appdataurl : item?.webdataurl ?? ""} isLoginRequired={item?.isLoginRequired ?? "false"}>
                    <div className={`flex w-full cursor-pointer justify-center items-center gap-[8px] ${index === 0 ? "border-r-2 border-r-[#e5e5e5]" : ""}`} >
                        <img
                            src={src}
                            alt={item?.imagealtText ?? ""}
                            width={16}
                            height={16}
                            loading="lazy"
                            decoding="async"
                            className="size-[16px] max-sm:size-[14px] object-contain"
                        />
                        <div>{item?.cardTitle}</div>
                    </div>
                </RedirectionHandler>
                );
            })}
        </div>
    );
};

export default SectorSection;